/* ---------------------------------------------------------------------------
 * MD Fashionwear — "You may also love" card builder
 *
 * FILLING IS NOT DONE HERE. md-cart-init.js is the single fill path and it loads
 * first on purpose. This file builds cards and exposes buildFrom(); its own
 * init() survives only as a last resort for md-cart-recs-boot.js.
 *
 * THE MARKET RULE LIVES IN ONE PLACE: MDCartPool.blocked(). Worldwide must NOT be
 * shown in-stock items — in-stock sits in the Lebanon local warehouse whose
 * delivery profile has only a Lebanon zone, so those pieces cannot ship abroad.
 * Do not re-add a tag check here; call the pool so the rule cannot drift.
 *
 * SIZE ROW — THREE STATES, ALL THE SAME HEIGHT
 * Cards must stay aligned, so the size row always occupies one row of height:
 *   several sizes  -> a dropdown
 *   exactly one    -> static text, "Size: STD". A one-option dropdown is
 *                     pointless, but leaving the row blank looked like a bug.
 *   no size option -> an invisible placeholder, so bags and jewellery still line
 *                     up with everything else
 *
 * PRICE UNITS: /products.json returns decimal strings ("55.00");
 * /products/{h}.js returns integer cents (5500). cents() normalises both.
 *
 * ADDING DOES NOT REBUILD THE DRAWER. It hands off to MDCartSync.afterAdd, which
 * swaps only the line items, shipping bar and totals. Dispatching cart:refresh
 * made the theme rebuild the whole drawer 2.8s later, wiping the carousel and
 * throwing the shopper back to the top. Do not reintroduce those events.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var SHOW = 24;
  var SVG_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.1C.5 8.4 2.2 4.8 5.6 4.1 8 3.6 10.4 4.8 12 7c1.6-2.2 4-3.4 6.4-2.9 3.4.7 5.1 4.3 3.6 7.8-2.5 4.5-10 9.1-10 9.1z"/></svg>';

  var reserve = [];
  var shownList = [];
  var excluded = {};

  /* ------------------------------------------------------------- helpers */

  function market() {
    var el = document.getElementById('cp-liquid-country');
    var c = (el && el.textContent.trim()) || (window.Shopify && window.Shopify.country) || '';
    return String(c).toUpperCase() === 'LB' ? 'LB' : 'WW';
  }

  function blocked(p, worldwide) {
    if (window.MDCartPool && window.MDCartPool.blocked) return window.MDCartPool.blocked(p, worldwide);
    return false;
  }

  function cents(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    var s = String(v);
    if (s.indexOf('.') > -1) return Math.round(parseFloat(s) * 100);
    return parseInt(s, 10) || 0;
  }

  function money(c) {
    if (window.MDCartSync && window.MDCartSync.fmt) return window.MDCartSync.fmt(c);
    if (window.MDWishlist && window.MDWishlist.formatMoney) return window.MDWishlist.formatMoney(c);
    return (c / 100).toFixed(2);
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function optPos(product, needles) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var name = String((typeof o === 'string' ? o : o.name) || '').toLowerCase();
      for (var j = 0; j < needles.length; j++) {
        if (name.indexOf(needles[j]) > -1) return (o && o.position) || (i + 1);
      }
    }
    return 0;
  }

  function sellable(product) {
    return (product.variants || []).filter(function (v) { return v.available; });
  }

  function productImage(product) {
    var imgs = product.images || [];
    if (!imgs.length) return '';
    return typeof imgs[0] === 'string' ? imgs[0] : imgs[0].src;
  }

  function imagesByColor(product, colorPos) {
    var map = {};
    if (!colorPos) return map;

    (product.variants || []).forEach(function (v) {
      var c = v['option' + colorPos];
      if (!c || map[c]) return;
      if (v.featured_image && v.featured_image.src) map[c] = v.featured_image.src;
    });

    (product.images || []).forEach(function (im) {
      if (typeof im === 'string' || !im.variant_ids) return;
      im.variant_ids.forEach(function (vid) {
        var v = (product.variants || []).filter(function (x) { return x.id === vid; })[0];
        if (!v) return;
        var c = v['option' + colorPos];
        if (c && !map[c]) map[c] = im.src;
      });
    });

    return map;
  }

  function swatchStyle(name, imgUrl) {
    var key = String(name || '').trim().toLowerCase();
    var map = window.MD_WISHLIST_COLORS || {};
    if (map[key]) return { kind: 'color', value: map[key] };

    var probe = document.createElement('span');
    probe.style.color = '';
    probe.style.color = key.replace(/\s+/g, '');
    if (probe.style.color) return { kind: 'color', value: probe.style.color };

    if (imgUrl) return { kind: 'image', value: sized(imgUrl, 40) };
    return { kind: 'color', value: '#dddad6' };
  }

  function persist() {
    if (window.MDCartStore) window.MDCartStore.save(shownList, reserve, excluded);
  }

  /* ---------------------------------------------------------------- card */

  function card(product) {
    var avail = sellable(product);
    if (!avail.length) return null;

    var wrap = document.createElement('div');
    wrap.className = 'md-rec';
    wrap.setAttribute('data-pid', product.id);

    var href = '/products/' + product.handle;
    var colorPos = optPos(product, ['color', 'colour']);
    var sizePos = optPos(product, ['size']);
    var colorImages = imagesByColor(product, colorPos);
    var chosen = avail[0];

    var media = document.createElement('a');
    media.className = 'md-rec__media';
    media.href = href;

    var img = document.createElement('img');
    img.alt = product.title || '';
    img.loading = 'lazy';
    media.appendChild(img);

    var heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'md-rec__heart';
    heart.setAttribute('data-wishlist-toggle', product.handle);
    heart.setAttribute('aria-label', mdT('md_cart_recs.save_to_wishlist', 'Save {title} to wishlist').replace('{title}', product.title || mdT('md_cart_recs.item', 'item')));
    heart.innerHTML = SVG_HEART;
    media.appendChild(heart);

    var title = document.createElement('a');
    title.className = 'md-rec__title';
    title.href = href;
    title.textContent = product.title || '';

    var price = document.createElement('p');
    price.className = 'md-rec__price';

    var colorsWrap = document.createElement('div');
    colorsWrap.className = 'md-rec__colors';

    var colorList = [];
    if (colorPos) {
      avail.forEach(function (v) {
        var c = v['option' + colorPos];
        if (c && colorList.indexOf(c) === -1) colorList.push(c);
      });
    }
    if (colorList.length < 2) colorsWrap.classList.add('md-rec__colors--empty');

    var sizeSel = document.createElement('select');
    sizeSel.className = 'md-rec__select';

    // Used when a product has exactly one size: shows it rather than a blank row.
    var sizeLine = document.createElement('p');
    sizeLine.className = 'md-rec__sizeline';

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'md-rec__add';
    add.textContent = mdT('md_cart_recs.add_to_cart', 'Add to cart');

    var state = { color: colorPos ? chosen['option' + colorPos] : null };

    function imageFor(color) {
      return (color && colorImages[color]) || productImage(product);
    }

    colorList.forEach(function (c) {
      var pre = new Image();
      pre.src = sized(imageFor(c), 400);
    });

    function matching() {
      return avail.filter(function (v) {
        return !colorPos || !state.color || v['option' + colorPos] === state.color;
      });
    }

    function currentVariant() {
      var pool = matching();
      if (!sizeSel.options.length || sizeSel.hidden) return pool[0] || avail[0];
      return pool.filter(function (v) { return String(v.id) === String(sizeSel.value); })[0] || pool[0] || avail[0];
    }

    function paintPrice() {
      var v = currentVariant();
      price.textContent = v ? money(cents(v.price)) : '';
      add.disabled = !v;
    }

    function paintImage() {
      var next = sized(imageFor(state.color), 400);
      if (next && img.getAttribute('src') !== next) img.src = next;
    }

    function paintSizes() {
      var pool = matching();
      sizeSel.innerHTML = '';

      if (sizePos && pool.length > 1) {
        // Several sizes: a real chooser.
        sizeSel.hidden = false;
        sizeSel.classList.remove('md-rec__select--ghost');
        sizeLine.hidden = true;

        pool.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v['option' + sizePos] || v.title;
          sizeSel.appendChild(o);
        });

      } else if (sizePos && pool.length === 1) {
        // One size only. Show what it is instead of an empty row.
        var only = pool[0]['option' + sizePos] || pool[0].title;
        sizeSel.hidden = true;
        sizeSel.classList.remove('md-rec__select--ghost');
        sizeLine.hidden = false;
        sizeLine.textContent = 'Size: ' + only;

      } else {
        // No size option at all. Keep the row's height so cards stay aligned.
        sizeSel.hidden = false;
        sizeSel.classList.add('md-rec__select--ghost');
        sizeLine.hidden = true;
      }

      paintPrice();
    }

    colorList.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'md-rec__swatch';
      b.title = c;
      b.setAttribute('aria-label', c);

      var s = swatchStyle(c, colorImages[c]);
      if (s.kind === 'image') {
        b.classList.add('md-rec__swatch--img');
        b.style.backgroundImage = 'url("' + s.value + '")';
      } else {
        b.style.background = s.value;
      }
      if (c === state.color) b.classList.add('is-selected');

      b.addEventListener('click', function () {
        if (state.color === c) return;
        state.color = c;
        [].forEach.call(colorsWrap.children, function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        paintImage();
        paintSizes();
      });

      colorsWrap.appendChild(b);
    });

    sizeSel.addEventListener('change', paintPrice);

    paintImage();
    paintSizes();

    add.addEventListener('click', function () {
      var v = currentVariant();
      if (!v || add.disabled) return;
      add.disabled = true;
      add.textContent = mdT('md_cart_recs.adding', 'Adding…');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (data) {
          var item = (data && data.items && data.items[0]) || null;

          excluded[String(product.id)] = true;
          backfill(wrap, product);

          if (window.MDCartSync && window.MDCartSync.afterAdd) {
            return window.MDCartSync.afterAdd(item);
          }
          if (item) document.dispatchEvent(new CustomEvent('variant:add', { detail: { items: [item] } }));
        })
        .catch(function () {
          add.disabled = false;
          add.textContent = mdT('md_cart_recs.add_to_cart', 'Add to cart');
        });
    });

    wrap.appendChild(media);
    wrap.appendChild(title);
    wrap.appendChild(price);
    wrap.appendChild(colorsWrap);
    wrap.appendChild(sizeSel);
    wrap.appendChild(sizeLine);
    wrap.appendChild(add);

    return wrap;
  }

  function backfill(oldCard, oldProduct) {
    var track = oldCard.parentElement;

    shownList = shownList.filter(function (p) { return String(p.id) !== String(oldProduct.id); });

    var ww = market() === 'WW';
    var replacement = null;
    var replacementProduct = null;

    while (reserve.length && !replacement) {
      var next = reserve.shift();
      if (next && !excluded[String(next.id)] && !blocked(next, ww)) {
        replacement = card(next);
        if (replacement) replacementProduct = next;
      }
    }

    if (track && replacement) {
      track.replaceChild(replacement, oldCard);
      shownList.push(replacementProduct);
    } else {
      oldCard.remove();
    }

    persist();
    if (window.MDWishlist && window.MDWishlist.sync) window.MDWishlist.sync();
    if (window.MDCartDots && window.MDCartDots.refresh) window.MDCartDots.refresh();
  }

  /* -------------------------------------------------------------- render */

  function useFallback(host) {
    host.hidden = true;
    var fb = document.getElementById('md-recs-fallback');
    if (fb) fb.hidden = false;
  }

  function paintInto(host, products) {
    var track = host.querySelector('.md-recs__track');
    if (!track) return 0;

    track.innerHTML = '';
    var placed = [];
    var ww = market() === 'WW';

    products.forEach(function (p) {
      if (placed.length >= SHOW) return;
      if (excluded[String(p.id)]) return;
      if (blocked(p, ww)) return;
      var c = card(p);
      if (c) { track.appendChild(c); placed.push(p); }
    });

    if (!placed.length) return 0;

    shownList = placed;
    host.hidden = false;
    var fb = document.getElementById('md-recs-fallback');
    if (fb) fb.hidden = true;

    if (window.MDWishlist && window.MDWishlist.sync) window.MDWishlist.sync();
    if (window.MDCartDots && window.MDCartDots.refresh) window.MDCartDots.refresh();
    return placed.length;
  }

  function buildFrom(shown, savedReserve, savedExcluded) {
    var host = document.getElementById('md-recs');
    if (!host || !shown || !shown.length) return false;

    excluded = savedExcluded || {};
    reserve = savedReserve || [];

    var placed = paintInto(host, shown);
    if (!placed) return false;

    host.setAttribute('data-ready', '1');
    persist();
    return true;
  }

  // Last resort only. md-cart-init.js is the real filler.
  function init() {
    var host = document.getElementById('md-recs');
    if (!host || host.getAttribute('data-ready') === '1') return;
    if (!window.MDCartPool) return;

    host.setAttribute('data-ready', '1');
    var ww = market() === 'WW';

    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = ((cart && cart.items) || []).map(function (i) { return String(i.product_id); });
        return window.MDCartPool.gather({ worldwide: ww, inCart: inCart, excluded: excluded, need: 48 });
      })
      .then(function (products) {
        if (!products || !products.length) { host.removeAttribute('data-ready'); useFallback(host); return; }
        reserve = products.slice(SHOW);
        if (!paintInto(host, products.slice(0, SHOW))) { host.removeAttribute('data-ready'); useFallback(host); return; }
        persist();
      })
      .catch(function () { host.removeAttribute('data-ready'); });
  }

  window.MDCartRecs = { init: init, buildFrom: buildFrom, market: market };
})();
